import { ApplyFeedFormInput } from 'views/bluviu-nutrition/features/scenarios-v2/types/feed-mappings-input.type';
import axios, { AxiosResponse } from 'axios';
import { AppliedScenario } from 'views/bluviu-nutrition/features/scenarios-v2/types/scenario-applied.type';

// /ewosapi/v1/scenarios/gt2-multi/{scenarioId}/apply
export const postScenarioApply = async (scenarioId: string, request: ApplyFeedFormInput): Promise<AxiosResponse> => {
  const response = await axios.post(`/ewosapi/v1/scenarios/gt2-multi/${scenarioId}/apply`, request);
  return response;
};

// /ewosapi/v1/scenarios/gt2-multi/{scenarioId}/applied-feed-programs/overview
export const getScenarioAppliedFeedProgramsOverview = async (scenarioId: string): Promise<AppliedScenario> => {
  const response = await axios.get(`/ewosapi/v1/scenarios/gt2-multi/${scenarioId}/applied-feed-programs/overview`);
  return response.data;
};
